<script setup lang="ts">
import { watch } from 'vue'
import { useUpgradeModal } from '@/composables/useUpgradeModal'
import { useDashboardHome } from '@/composables/useDashboardHome'
import ApiErrorNotification from '@/components/generic/ApiErrorNotification.vue'
import DashboardDataLoading from '@/components/dashboard/ui/DashboardDataLoading.vue'
import DashboardNotificationsSection from '@/components/dashboard/notifications/DashboardNotificationsSection.vue'
import DashboardHomeFree from '@/components/dashboard/home/DashboardHomeFree.vue'
import DashboardHomePaid from '@/components/dashboard/home/DashboardHomePaid.vue'
import { useMarkDashboardSeen } from '@/composables/useMarkDashboardSeen'
import { scrollWindowToTopSoon } from '@/helpers/scrollWindowToTop'

const { openUpgradeModal } = useUpgradeModal()
useMarkDashboardSeen()

const { homeState, isPageLoading, apiError, sortedYears, paidCurrentYear } =
  useDashboardHome()

// Final paint of home content can reintroduce a restored scroll offset.
watch(isPageLoading, (loading) => {
  if (!loading) {
    scrollWindowToTopSoon()
  }
})
</script>

<template>
  <div>
    <ApiErrorNotification
      v-if="apiError"
      link="Dashboard"
      aria-label="Donations API error"
    >
      An error has occurred while fetching donations, please
      <strong>try again</strong>
      .
    </ApiErrorNotification>
    <DashboardDataLoading v-else-if="isPageLoading" />
    <div
      v-else
      class="sa-page-stack"
      :class="{ 'sa-stack': homeState === 'free' }"
    >
      <DashboardNotificationsSection />
      <DashboardHomePaid
        v-if="homeState === 'paid'"
        :current-year="paidCurrentYear"
        :sorted-years="sortedYears"
      />
      <DashboardHomeFree
        v-else-if="homeState === 'free'"
        @upgrade="openUpgradeModal"
      />
    </div>
  </div>
</template>
